import {request} from '../services/request';
import {backendEndpoints} from '../../api';
import {apiHelpers} from '../../utils/helpers';
import {cardConstants} from '../constants';

const errorHandlerProps = {disableAlert: true};
const hideKeylessErrorHandlerProps = {hideKeylessError: true};

const {getUrl} = apiHelpers;

const getCards = (query = null, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_CARDS,
      query,
      successCallback,
      errorCallback
    });
  }
}

const getUserCards = ({query = null, successCallback, errorCallback} = {}) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_CARDS_USER,
      query,
      successCallback,
      errorCallback
    });
  }
}

const getCardsSummaries = (query = null, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: backendEndpoints.GET_CARDS_SUMMARIES_LIST,
      query,
      successCallback: (data) => {
        dispatch({ data, type: cardConstants.GET_CARDS_SUMMARIES });
        successCallback && successCallback(data);
      },
      errorCallback
    });
  }
}



const getCard = (id, successCallback, errorCallback) => {
  return (dispatch) => {
    request.get({
      dispatch,
      url: getUrl(backendEndpoints.GET_CARD, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const createPhysicalCard = ({headers, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      headers,
      url: backendEndpoints.POST_CREATE_PHYSICAL_CARD,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const createVirtualCard = ({headers, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    request.post({
      dispatch,
      headers,
      url: backendEndpoints.POST_CREATE_VIRTUAL_CARD,
      data,
      successCallback,
      errorCallback,
      errorHandlerProps
    });
  }
}

const deleteCard = ({headers, id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    request.delete({
      dispatch,
      data,
      headers,
      url: getUrl(backendEndpoints.DELETE_CARD, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps: hideKeylessErrorHandlerProps
    });
  }
}

const pauseCard = ({headers, id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      data,
      headers,
      url: getUrl(backendEndpoints.PUT_PAUSE_CARD, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps: hideKeylessErrorHandlerProps
    });
  }
}

const updateCard = ({headers, id, data, successCallback, errorCallback}) => {
  return (dispatch) => {
    request.put({
      dispatch,
      data,
      headers,
      url: getUrl(backendEndpoints.PUT_UPDATE_CARD, {id}),
      successCallback,
      errorCallback,
      errorHandlerProps: hideKeylessErrorHandlerProps
    });
  }
}

const storeCards = (data) => {
  return (dispatch) => {
    dispatch({
      type: cardConstants.STORE_CARDS,
      data
    });
  }
}

export const cardActions = {
  createPhysicalCard,
  createVirtualCard,
  deleteCard,
  getCard,
  getCards,
  getUserCards,
  getCardsSummaries,
  pauseCard,
  updateCard,
  storeCards
};
